'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function queryOptions(options) {
  return options;
}

exports.queryOptions = queryOptions;
//# sourceMappingURL=queryOptions.js.map
